import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateNoteMutation as CreateNoteMutationType,
  CreateNoteMutationVariables,
} from "./__generated__/CreateNoteMutation";

const CreateNoteMutation = loader("./CreateNoteMutation.gql");

type CreateNoteMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError?: (error: ApolloError) => void;
  onCompleted?: (data: CreateNoteMutationType) => void;
}) => ReactElement;

export const CreateNoteMutationProvider: CreateNoteMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateNoteMutationType, CreateNoteMutationVariables>(CreateNoteMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
    refetchQueries: ["GetContextQuery"],
    awaitRefetchQueries: true,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
